import Swal from "sweetalert2";
import config from "./Config";

export const refreshToken = async ({ navigate, onSuccess, onError, autoReload = false } = {}) => {
    let success = false;

    try {
        const refreshToken = localStorage.getItem("digital-form-refresh_token");

        if (!refreshToken) throw new Error("Refresh token is missing");

        const response = await fetch(`${config.API_BASE_URL}/auth/refresh_token`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "practice": localStorage.getItem("digital-form-dept-practice")
            },
            body: JSON.stringify({ refreshtoken: refreshToken }),
        });

        if (response.status !== 200) {
            if (response.status === 400) {
                clearAuthStorage();
                Swal.fire({
                    icon: "warning",
                    title: "Session Expired",
                    text: "Your session has expired. Please log in again.",
                    confirmButtonText: "Login",
                }).then(() => {
                    if (navigate) navigate("/");
                });
                return false;
            }

            Swal.fire({
                icon: "error",
                title: "Unexpected Error",
                text: "Unable to refresh token",
                confirmButtonText: "Close",
            }).then(() => {
                clearAuthStorage();
                if (navigate) navigate("/");
            });
            return false;
        }

        const res = await response.json();
        const { token } = res;

        if (token?.access_token && token?.refresh_token) {
            const expiryTime = Date.now() + token.expires_in * 1000;

            localStorage.setItem("digital-form-accesstoken", token.access_token);
            localStorage.setItem("digital-form-idtoken", token.access_token);
            localStorage.setItem("digital-form-refresh_token", token.refresh_token);
            localStorage.setItem("digital-form-expiry", expiryTime);

            success = true;
            if (onSuccess) onSuccess(token);
            if (autoReload) window.location.reload();
        } else {
            Swal.fire({
                icon: "error",
                title: "Token Error",
                text: "Token data missing in response.",
                confirmButtonText: "Close",
            }).then(() => {
                clearAuthStorage();
                if (navigate) navigate("/");
            });
            if (onError) onError();
        }

        return success;
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: "Error",
            text: error.message,
            confirmButtonText: "Close",
        }).then(() => {
            clearAuthStorage();
            if (navigate) navigate("/");
        });
        if (onError) onError(error);
        return false;
    }
};

function clearAuthStorage() {
    localStorage.removeItem("digital-form-accesstoken");
    localStorage.removeItem("digital-form-idtoken");
    localStorage.removeItem("digital-form-refresh_token");
    localStorage.removeItem("digital-form-expiry");
    localStorage.removeItem("digital-form-dept-practice");
}
